import React from "react"

import { Container } from "./styles"

const SignupForm = ({ elRef, element }) => {
  const { promotionalUnit } = element

  if (!promotionalUnit) {
    return null
  }

  return <Container elRef={elRef} component={promotionalUnit} isPromotionalPlacement />
}

export default SignupForm
